import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { IonContent } from "@ionic/angular";
import { Navigator } from "src/app/components/menu/navigator";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { WithdrawalService } from "src/app/services/cashier/withdrawal.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { WithdrawalBaseComponent } from "../withdrawal-base/withdrawal-base.component";


@Component({
    selector: 'page-withdrawal-interac-add',
    templateUrl: 'withdrawal-interac-add.html',
})
export class WithdrawalInteracAddPage extends WithdrawalBaseComponent implements OnInit {
    @ViewChild('Content') content: IonContent;
    @Input() navigateBackPage: string;
    
    private error = null;
    
    private addAccountForm: FormGroup;

    private transitNumber: AbstractControl;
    private institutionNumber: AbstractControl;
    private accountNumber: AbstractControl;
    private bankName: AbstractControl;
    private payment_type_code: AbstractControl;
    
    private accounts: any = [];


    constructor(
        // private logger: Logger,
        private navigator: Navigator,
        private withdrawService: WithdrawalService,
        private cashierProvider: CashierService,
        public utils:UtilsService,
        private successMessageService: SuccessMessageService) {
        
        super();
        


        this.successMessageService.clearMessage();
        this.error = null;
    }

    ngOnInit() {
        this.addAccountForm = new FormGroup(
            {
                transitNumber: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern('^[0-9]*')]),
                institutionNumber: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(3), Validators.pattern('^[0-9]*')]),
                accountNumber: new FormControl('', [Validators.required, Validators.maxLength(12), Validators.pattern('^[0-9]*')]),
              
            }
        )

        this.transitNumber = this.addAccountForm.get('transitNumber');
        this.institutionNumber = this.addAccountForm.get('institutionNumber');
        this.accountNumber = this.addAccountForm.get('accountNumber');
    
    
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad WithdrawalECheckAddPage');
    }

    onAddAccount() {
        this.successMessageService.clearMessage();
        this.error = null;
        
        let addAccountFormObj: any = this.addAccountForm.value;
        addAccountFormObj.payment_type_code = "MNI";


        this.cashierProvider.callAddAccount(addAccountFormObj).subscribe(
            (response: any) => {
                if (response && !!response.result ) {
                    if (response.payload != null) {
                        this.successMessageService.setMessage('Thank you, your bank account was successfully added.');
                        this.addAccountForm.reset();
                        this.content.scrollToTop();
                        this.navigator.navigateTo("WithdrawalInteracPage");
                    }
                }
            },
            (error) => {
                this.error = this.handleError(error);
                // this.logger.log("onAddAccount error = ", error);
                this.content.scrollToTop();
            }
        )

        this.error = null;
    }


    onBack = () => {
        if (!!this.navigateBackPage) {
            this.navigator.navigateTo(this.navigateBackPage);
        } else {
            this.navigator.back();
        }
    }
}